const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '7x24小时不间断追踪娱乐圈最新动态，今日黑料第一时间推送到你面前，绝不让你错过任何一个大瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每一条黑料爆料均经过编辑团队交叉验证，确保信息真实可靠，拒绝虚假炒作和标题党内容。',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '百万吃瓜群众在线交流，可以在评论区畅所欲言，分享你的观点和独家线索，一起愉快吃瓜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">为什么选择51黑料</h2>
            <p className="text-sm text-foreground-600 mt-2">我们的三大核心优势</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="rounded-2xl bg-background-50 border border-background-200/60 p-6 md:p-8 text-center group hover:border-primary-300 transition-all"
              >
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${feat.icon} text-2xl text-primary-600 w-7 h-7 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{feat.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}